import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

function validateMsalConfig() {
  const clientId = msalConfig.auth?.clientId;
  const authority = msalConfig.auth?.authority;
  const apiScope = (process.env.REACT_APP_AZURE_AD_API_SCOPE || "").trim();

  if (!clientId) {
    throw new Error("Missing REACT_APP_AZURE_AD_CLIENT_ID");
  }

  if (!authority) {
    throw new Error(
      "Missing REACT_APP_AZURE_AD_AUTHORITY (expected e.g. https://login.microsoftonline.com/common)"
    );
  }

  if (!apiScope) {
    throw new Error(
      "Missing REACT_APP_AZURE_AD_API_SCOPE (expected e.g. api://<API_CLIENT_ID>/access_as_user)"
    );
  }

  let url: URL;
  try {
    url = new URL(authority);
  } catch {
    throw new Error(
      `Invalid REACT_APP_AZURE_AD_AUTHORITY: '${authority}' (expected a full https URL)`
    );
  }

  if (!url.hostname) {
    throw new Error("Invalid REACT_APP_AZURE_AD_AUTHORITY: missing hostname");
  }

  if (url.protocol !== "https:") {
    throw new Error("Invalid REACT_APP_AZURE_AD_AUTHORITY: must be https");
  }

  const pathname = url.pathname.replace(/\/+$/, "");
  if (!pathname || pathname === "/") {
    throw new Error(
      "Invalid REACT_APP_AZURE_AD_AUTHORITY: missing segment (expected https://login.microsoftonline.com/common)"
    );
  }

  if (pathname.includes("oauth2") || pathname.includes("authorize") || pathname.includes("token")) {
    throw new Error(
      "Invalid REACT_APP_AZURE_AD_AUTHORITY: must be the base authority (e.g. https://login.microsoftonline.com/<TENANT_ID>), not an /oauth2/... endpoint"
    );
  }
}

let cached: PublicClientApplication | null = null;

export function getMsalInstance(): PublicClientApplication {
  if (cached) return cached;
  validateMsalConfig();
  cached = new PublicClientApplication(msalConfig);
  return cached;
}
